import { adminHttpClient } from '../../commons/adminHttpClient'

export interface AddMigrationQueueRequest {
  companyIds: string[]
  scheduleDate: Date
}

const addMigrationQueue = (request: AddMigrationQueueRequest): Promise<any> => {
  return adminHttpClient.post(`/csi/MigrationQueue`, request)
}

export default addMigrationQueue
